import React from 'react';
//import { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart,  Pie, Cell } from 'recharts';
import './AirlineChart.css';

const COLORS = ['#DC3545','#00C49F','#8884D8','#FF8042','#1281DA','#ee50b4','#27C966','#070e9f','#FF5722','#00BCD4','#FFC107','#3F51B5','#9C27B0'];

function AirlineChart({ data }) {
  //const [hoveredCol, setHoveredCol] = useState(null);

  if (!data || Object.keys(data).length === 0) {
    return (
      <section className="airline-chart-container">
        <div className='warning-wrap alert-msg-box d-flex'>
          <span className='icon warning-icon'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-triangle-alert">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/>
              <path d="M12 9v4"/>
              <path d="M12 17h.01"/>
            </svg>
          </span>
          <span className='alert-title'>No airline data available</span>
        </div>
      </section>
    );
  }

  // Convert object to array for chart
  const chartData = Object.entries(data).map(([airline, count]) => ({
    name: airline,
    value: count
  })).filter((item) => item.name);

  
 

  return (
    <>
      {/* <section className="airline-chart-container"></section> */}
       {/* <div className="detailed-breakdown airline-table" style={{display:'none'}}>
          <h3>Detailed Breakdown</h3>
          <div className='detailed-breakdown-data'>
            <table className='detailed-breakdown-table'>
              <thead>
                <tr>
                  <th style={{textAlign:'left'}}>Airline Code</th>
                  <th style={{textAlign:'center'}}>Tickets Sold</th>
                  <th style={{textAlign:'right'}}>Percentage</th>
                </tr>
              </thead>
              <tbody>
                {chartData.map((item, index) => {
                  const total = chartData.reduce((sum, d) => sum + d.value, 0);
                  const percentage = ((item.value / total) * 100).toFixed(2);
                  return (
                    <tr key={index}>
                      <td className="airline-code" style={{textAlign:'left'}}>{item.name}</td>
                      <td className="ticket-count" style={{textAlign:'center'}}>{item.value.toLocaleString()}</td>
                      <td className="percentage" style={{textAlign:'right'}}>{percentage}%</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div> */}

       

       

      <div className="chart-section">  
        <div className="charts-wrapper">
          <div className="chart chart-bar">
            <h6 className='chart-title'>Bar Chart</h6>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value">
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="chart">
            <h6 className='chart-title'>Distribution</h6>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={chartData} cx="50%" cy="50%" labelLine={true} dataKey="value"   outerRadius={95}
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`} >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie> {/*  outerRadius={80} */}
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div> 

      </div>
    </>
  );
}

export default AirlineChart;
